import React from 'react';
import { Badge, BadgePriority } from 'wix-ui-tpa/cssVars';
import type { FeaturedType } from 'root/clientTypes';
import { dataHooks } from 'root/dataHooks';
import { st, classes } from './FeaturedBadge.st.css';
import { useFeaturedBadgeLogic } from './FeaturedBadge.logic';

export const FeaturedBadge = ({ featuredType }: { featuredType?: FeaturedType }) => {
  const { label, isVisible, isOnImage } = useFeaturedBadgeLogic({ featuredType });

  if (!isVisible) {
    return null;
  }

  return (
    <Badge
      className={st(classes.featuredBadge, { onImage: isOnImage })}
      data-hook={dataHooks.item.featuredBadge}
      data-placement={isOnImage ? 'image' : 'item-info'}
      priority={BadgePriority.light}
    >
      <div className={classes.featuredBadgeName}>{label}</div>
    </Badge>
  );
};
